import {
  Calendar, Zap, UtensilsCrossed, Star, Clock, Trophy, Ticket, Edit3,
  Users, UserX, UserPlus, TrendingUp, TrendingDown, Repeat,
} from 'lucide-react';

export const TEMPLATE_ICONS = {
  calendar: Calendar, zap: Zap, utensils: UtensilsCrossed,
  star: Star, clock: Clock, trophy: Trophy, ticket: Ticket, edit: Edit3,
};

export const TIERS = [
  { value: 'bronze', label: 'Bronze' },
  { value: 'silver', label: 'Silver' },
  { value: 'gold', label: 'Gold' },
  { value: 'platinum', label: 'Platinum' },
];

export const SEGMENTS = [
  { value: '', label: 'Tutti', icon: Users },
  { value: 'inactive', label: 'Inattivi', icon: UserX },
  { value: 'new', label: 'Nuovi', icon: UserPlus },
  { value: 'top_month', label: 'Top mese', icon: Trophy },
];

export const SPENDING_SEGMENTS = [
  { value: '', label: 'Tutti' },
  { value: 'high_spender', label: 'Alto spend.', icon: TrendingUp },
  { value: 'low_spender', label: 'Basso spend.', icon: TrendingDown },
];

export const FREQUENCY_SEGMENTS = [
  { value: '', label: 'Tutti' },
  { value: 'high_frequency', label: 'Alta freq.', icon: Zap },
  { value: 'recurring', label: 'Ricorrente', icon: Repeat },
];

export function PillButton({ active, onClick, children, testId }) {
  return (
    <button
      onClick={onClick}
      data-testid={testId}
      className={`flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-[11px] font-medium border transition-all ${
        active
          ? 'bg-[#D44E20] text-white border-[#D44E20] shadow-sm'
          : 'bg-white text-[#64748B] border-slate-200 hover:bg-slate-50 hover:border-gray-300'
      }`}
    >
      {children}
    </button>
  );
}


// SMS segment estimator (GSM-03.38). A single SMS holds 160 GSM-7 chars
// (or 70 if it contains characters outside the GSM-7 alphabet → UCS-2).
// Longer messages are split into concatenated parts of 153 (GSM-7) / 67
// (UCS-2) chars, and EACH part is billed separately by the carrier.
const GSM7_BASIC = "@\u00a3$\u00a5\u00e8\u00e9\u00f9\u00ec\u00f2\u00c7\n\u00d8\u00f8\r\u00c5\u00e5\u0394_\u03a6\u0393\u039b\u03a9\u03a0\u03a8\u03a3\u0398\u039e\u001b\u00c6\u00e6\u00df\u00c9 !\"#\u00a4%&'()*+,-./0123456789:;<=>?\u00a1ABCDEFGHIJKLMNOPQRSTUVWXYZ\u00c4\u00d6\u00d1\u00dc\u00a7\u00bfabcdefghijklmnopqrstuvwxyz\u00e4\u00f6\u00f1\u00fc\u00e0";
const GSM7_EXT = "^{}\\[~]|\u20ac";

export function smsSegments(text) {
  const s = text || '';
  let isGsm = true;
  for (const ch of s) {
    if (GSM7_BASIC.indexOf(ch) === -1 && GSM7_EXT.indexOf(ch) === -1) { isGsm = false; break; }
  }
  let count;
  if (isGsm) {
    count = 0;
    for (const ch of s) count += GSM7_EXT.indexOf(ch) !== -1 ? 2 : 1;
  } else {
    count = [...s].length;
  }
  const single = isGsm ? 160 : 70;
  const multi = isGsm ? 153 : 67;
  const segments = count === 0 ? 1 : count <= single ? 1 : Math.ceil(count / multi);
  return { encoding: isGsm ? 'GSM-7' : 'UCS-2', chars: count, segments, limitPerPart: single };
}
